import {ReactElement, useState} from "react";
import {styled} from "styled-components";

import {ErrorBoundary} from "@/components/ErrorBoundary/ErrorBoundary";
import {FournisseurResultat as FournisseurElement} from "@/components/Fournisseur/FournisseurResultat/FournisseurResultat";
import {FournisseurSearch} from "@/components/Fournisseur/FournisseurSearch/FournisseurSearch";
import {HookFormContextProvider} from "@/context/HookFormContext";
import {useIsConnectedTest} from "@/hooks/useIsConnectedTest/useIsConnectedTest";
import {FournisseurSearch as TypeFournisseurSearch} from "@/ts/fournisseur";
import {Pagination} from "@/ts/pagination";

const ContentPageStyled = styled.div`
  width: 100%;
`;

const ContentFournisseursResultat = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  row-gap: 3.5rem;
  column-gap: 3rem;
  justify-content: center; // ← centre aussi les lignes incomplètes
  width: 100%;
`;

export function FournisseurResultat(): ReactElement | null {
  // Vérifie si l'utilisateur est connecté et redirige vers la page de connexion si ce n'est pas le cas
  const isAuthorized = useIsConnectedTest();

  const [fournisseurs, setFournisseurs] = useState<TypeFournisseurSearch[]>([]);
  const [pagination, setPagination] = useState<Pagination | null>(null);

  // si l'utilisateur n'est pas connecté, on ne rend pas la page
  if (!isAuthorized) {
    return null;
  }

  return (
    <ContentPageStyled data-testid="ContentPageStyled">
      <h1 style={{textAlign: "center"}}>Rechercher un fournisseur</h1>
      <HookFormContextProvider defaultValues={{filtre: "all"}}>
        <FournisseurSearch
          updateFournisseurList={setFournisseurs}
          updatePagination={setPagination}
          pagination={pagination}>
          <ErrorBoundary
            fallbackText="Erreur lors de la récupération des fournisseurs"
            buttonToRefresh={true}>
            <ContentFournisseursResultat data-testid="ContentFournisseursResultat">
              {fournisseurs.map((fournisseur, index) => {
                return (
                  <FournisseurElement
                    key={`${fournisseur.nom}-${index}`}
                    fournisseurName={fournisseur.nom}
                    logo={fournisseur.logo}
                    data-testid="FournisseurElement"
                    idFournisseur={fournisseur.fournisseur_id}
                  />
                );
              })}
            </ContentFournisseursResultat>
          </ErrorBoundary>
        </FournisseurSearch>
      </HookFormContextProvider>
    </ContentPageStyled>
  );
}
